import Styles from "./index.module.scss";

const ArticleVideos = ({ data = {} }) => {
  return data?.map(item => {
    const {
      pageDescription_s,
      pageTitle_s,
      canonicalUrl_s,
      id,
      keywords_s,
      buFilter_s,
      indexedTime_s,
      pageType_s,
    } = item;
    const isValidHref =
      canonicalUrl_s &&
      typeof canonicalUrl_s === "string" &&
      canonicalUrl_s.trim().length > 0;

    let hrefPath = "";
    if (isValidHref) {
      if (canonicalUrl_s.startsWith("https://")) {
        const pathSegments = canonicalUrl_s
          ?.split("https://")[1]
          ?.split("/")
          ?.slice(1)
          ?.join("/");
        hrefPath = pathSegments ? `/${pathSegments}` : canonicalUrl_s;
      }
    }

    return (
      <div
        className={Styles.productArticles}
        key={id || canonicalUrl_s || pageTitle_s}
      >
        <div className="article-content">
          {pageTitle_s && (
            <span className="article-title">
              {pageTitle_s.replace(/&amp;/g, "and")}{" "}
            </span>
          )}
          {pageDescription_s && (
            <span className="article-description">
              {pageDescription_s.replace(/&amp;/g, "and")}{" "}
            </span>
          )}
          <span className="article-date"></span>
          {isValidHref ? (
            <a
              href={hrefPath}
              className="article-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Read The Article
            </a>
          ) : (
            <button
              type="button"
              className="article-link"
              style={{
                background: "none",
                border: "none",
                padding: 0,
                color: "inherit",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              Read The Article
            </button>
          )}
        </div>
      </div>
    );
  });
};

export default ArticleVideos;
